export const FORMAT = Object.freeze({
  EMPTY: "",
  NL: "\n"
});

export const ERROR = Object.freeze({
  AUTHENTICATION_FAILED: "Autenticazione fallita.",
  SERVER_ERROR: "Errore del server.",
  SERVER_CONNECTION_ERROR: "Errore di connessione al server.",
  SESSION_EXPIRED: "Sessione scaduta.",
  SERVICE_ACCESS_NOT_AUTHORIZED: "Accesso al servizio non autorizzato.",
  RET_ACCESS_NOT_AUTHORIZED: "Accesso allo scrutinio non autorizzato.",
  VERIFY_SCHEDULING: "Verificare gli orari e le modalità di scrutinio.",
  RET_IDENTIFICATION: "Errore nell'identificazione dello scrutinatore.",
  ELECTION_EVENT: "Evento elettorale non trovato.",
  COUNTING_INFORMATION: "Errore nel recupero dei gruppi.",
  COUNTING_STATUS: "Errore nel recupero dello stato dei gruppi.",
  ELECTION_GROUP_COUNT:
    "Errore nel recupero dello stato attuale dello scrutinio.",
  START_ELECTION_GROUP_COUNT: "Errore nell'avvio dello scrutinio.",
  NEXT_ELECTION_GROUP_COUNT:
    "Errore nell'avvio della successiva elezione in sequenza da scrutinare.",
  DOWNLOAD: "Errore nel dowload del file di report.",
  SEND_REPORT_TO_GEA: "Errore nell'invio del report a GEA",
  STOP_ELECTION_GROUP_COUNT: "Errore nell'interruzione dello scrutinio."
});
